import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import ServiceCard from '../ServiceCard/ServiceCard';
const BaggageRefundCard = props => {
    const { t } = useTranslation('Checkout');
    const theme = useTheme('RefundSummary').CommonContent;
    return (React.createElement(ServiceCard, Object.assign({ type: "baggage", className: theme.serviceCard_baggage, title: t('Baggage'), description: t('Transportation of impressions no limitations') }, props)));
};
export default BaggageRefundCard;
